<!DOCTYPE html>
<html lang="en" xml:lang="en">

<head>
  <meta charset="UTF-8" />
  <title>InterMiles Flights Backend</title>
</head>

<body>
  <div class="login-card">
    <div class="logo">
      <img src="assets/img/demologo1.png" alt="not found" />
    </div>
    <div class="err" id="error"></div>
    <h1>LogIn</h1>
    <br />
    <form>
      <label>User Name</label>
      <div class="user">
        <input type="text" name="user" placeholder="example@gmail.com" [(ngModel)]="screen_details.EMAIL" id="email"
          [pattern]="emailPattern" #email="ngModel" (blur)="checkEmailNames($event.target.value)"
          (keyup)="emptyValidation($event.target.value, 1)" (input)="clearErroMassages(1)" />

        <span id="UserNameErr"> </span>
      </div>
      <div class="password">
        <label>Password</label>
        <input type="password" name="pass" placeholder="**********" [(ngModel)]="screen_details.PASSWORD" id="pwd"
          [pattern]="passwordPattern" #password="ngModel" (keyup)="emptyValidation($event.target.value, 2)"
          (input)="clearErroMassages(2)" />

        <span id="passwordErr"> </span>

        <div class="logdiv">
          <span class="text-leftforgot">
            <a routerLink="/forgot">Forgot Password?</a>
          </span>
          <span class="text-right">
            <input type="submit" name="login" class="login login-submit" (click)="submitdata()" value="Login"
              (input)="onInputPassword()" />
          </span>
        </div>
      </div>
    </form>
  </div>
</body>

</html>